// Field name mapping utility for Leaders page
// Maps stat category IDs to actual field names in the unified stats function

export const getFieldName = (option, isTotal) => {
    // Special case for player_games
    if (option === 'player_games') {
        return isTotal ? 'total_player_games' : 'average_player_games';
    }

    // Fields that don't have total_ prefix in unified stats
    if (option === 'games_starting' || option === 'games_minutes') {
        return option;
    }

    // Field name mapping to match database function output
    const fieldMapping = {
        'goal': 'goals',  // Plural form
        'passes': 'passes',
        'successful_passes': 'passes_success',
        'passes_for_goals': 'assists',
        'key_passes': 'key_passes',
        'through_passes': 'through_passes',
        'through_passes_successful': 'through_passes_success',
        'passes_for_shots': 'passes_for_shots',
        'shot': 'shots',
        'shot_on_target': 'shots_on_target',
        'shot_off_target': 'shots_off_target',
        'shot_on_box': 'shots_in_the_box',
        'shot_out_of_box': 'shots_out_of_the_box',
        'free_kick': 'freekick_passes',
        'crosses': 'crosses',
        'penalties': 'penalties',
        'penalties_missed': 'penalties_missed',
        'dribble': 'dribbles',
        'dribble_successful': 'dribbles_success',
        'dribble_unsuccessful': 'dribbles_fail',
        'turnover': 'turnovers',
        'turnover_on_defensive_court': 'turnovers_on_defensive_court',
        'turnover_on_offensive_court': 'turnovers_on_offensive_court',
        'offside': 'offsides',
        'own_goals': 'own_goals',
        'tackle': 'tackles',
        'tackle_on_offensive_court': 'tackle_on_offensive_court',
        'tackle_on_defensive_court': 'tackle_on_defensive_court',
        'clearance': 'clearances',
        'interception': 'interceptions',
        'interception_on_defensive_court': 'interception_on_defensive_court',
        'interception_on_offensive_court': 'interception_on_offensive_court',
        'fouls': 'fouls',
        'draw_fouls': 'draw_fouls',
        'red_cards': 'red_cards',
        'yellow_cards': 'yellow_cards',
        'saved': 'saved'
    };

    const mappedField = fieldMapping[option] || option;
    return isTotal ? `total_${mappedField}` : `average_${mappedField}`;
};
